import React from 'react';
import { PublicPage, PublicCard } from '../PublicPage';
import { Accordion } from '../../../components/Accordion/Accordion';
import { FAQ_CATEGORIES } from './faqContent';

/**
 * Facilon FAQs — 33 questions in five sections, mirroring the published page.
 * Content lives in faqContent.ts; this file is only the presentation.
 */
export const Faq: React.FC = () => (
  <PublicPage
    title="Frequently Asked Questions"
    subtitle="Answers about Facilon, how the platform works, and what it costs."
    icon="bi-question-circle-fill"
  >
    {FAQ_CATEGORIES.map((category, ci) => (
      <PublicCard key={category.title} title={category.title} icon="bi-chevron-double-right">
        {/* The very first question opens by default so the page never reads as a
            wall of collapsed bars. */}
        <Accordion items={category.items} defaultOpen={ci === 0 ? 0 : undefined} />
      </PublicCard>
    ))}
  </PublicPage>
);

export default Faq;
